import * as React from "react";
import { useSelector } from "react-redux";
import * as AppTypes from "AppTypes";
import { classNames } from "../../utils";

import "./messageContainer.scss";
import { appActions } from "../../actions";
import Modal from "../Modal";
import { dispatch } from "../../store";

export const popMessage = () => {
  dispatch(appActions.popMessage());
};

interface IAddMessage {
  img?: string;
  title?: string;
  text?: string;
  noActions?: boolean;
  confirmFn?: () => void;
  cancelFn?: () => void;
  buttons?: {
    confirm?: string;
    cancel?: string;
  };
}

export const addMessage = ({
  img,
  title,
  text,
  buttons,
  confirmFn = () => {},
  cancelFn = () => {},
  noActions,
}: IAddMessage) =>
  new Promise((resolve, reject) =>
    dispatch(
      appActions.addMessage(
        <Modal
          img={img}
          title={title}
          text={text}
          confirmFn={() => {
            popMessage();
            confirmFn();
            resolve(true);
          }}
          cancelFn={() => {
            popMessage();
            cancelFn();
            resolve(false);
          }}
          buttons={buttons}
          noActions={noActions}
        />
      )
    )
  );

const MessageContainer = () => {
  const storeApp = useSelector((store: AppTypes.ReducerState) => {
    return store.app;
  });

  const shownMessage = storeApp?.messages[0] || null;
  const storeAppMessages = storeApp?.messages;

  React.useEffect(() => {
    const body = document.getElementsByTagName("body")[0];
    if (storeAppMessages.length > 0) {
      body.setAttribute("data-lock", "true");
    } else {
      body.removeAttribute("data-lock");
    }
  }, [shownMessage, storeAppMessages]);

  return (
    <div
      className={classNames({
        "app-message-container": true,
        "app-message-container--hide": storeAppMessages.length < 1,
      })}
    >
      {shownMessage}
    </div>
  );
};

export default MessageContainer;
